export default {
  colors: {
    background: '#F6F5FC',
    darkerBackground: '#cac5e8',
    lighterBackground: '#fff',
    defaultBorder: '#dededf',
    backgroundWithOpacity: 'rgba(246, 245, 252, 0.7)',

    primary: {
      lighter: '#bbedfb',
      light: '#4aafff',
      main: '#0075b2',
      dark: '#00011e',
    },

    chart: {
      main: '#4aafff',
    },

    blue: {
      50: '#afe6ff',
      100: '#1097e5',
      200: '#005481',
      900: '#003250',
    },

    gray: {
      900: '#566a7f',
      201: '#bcbcbc',
      200: '#bcbcbc',
      100: '#d9d9d9',
      75: '#E6E6E6',
      50: '#f1f1f1',
    },

    green: {
      500: '#3ea76a',
      100: '#c2ebd4',
    },

    orange: {
      500: '#da7c0f',
      100: '#fddcb2',
    },

    danger: {
      lighter: '#feb5b5',
      light: '#feb5b5',
      main: '#FC5050',
      dark: '#F63131',
    },

    pastelScale: {
      1: '#3ea76a',
      2: '#005481',
      3: '#da7c0f',
      4: 'rgb(223, 90, 73)',
      5: 'rgb(85, 219, 193)',
      6: 'rgb(239, 218, 151)',
      7: 'rgb(223, 148, 138)',
      8: 'rgb(51, 77, 92)',
    }
  },

  filters: {
    primary: 'invert(24%) sepia(58%) saturate(3480%) hue-rotate(183deg) brightness(96%) contrast(101%)',
    oppositeTheme: 'brightness(0) saturate(100%) invert(0%) sepia(85%) saturate(7500%) hue-rotate(173deg) brightness(88%) contrast(112%)',
    sameAsTheme: 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(1%) hue-rotate(275deg) brightness(105%) contrast(101%)',
  },
};
